// @flow
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../plugins/jquery.password-toggle';

/**
 * password toggle - prepinani type = password | text
 *
 */
export default class PasswordToggle extends WebComponent {
	didMount() {
		$(this.element).passwordToggle();
	}
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/PasswordToggle.js